module.exports = __webpack_public_path__ + "img/tech-11.17b2272b.jpg";